import { ReactElement, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";

import PageContainer from "../components/shared/PageContainer";
import TemplateSetForm from "../components/template-set/TemplateSetForm";
import { Profile, Profiles, TemplateSet } from "../services/api";

function TemplateSetCreate() {
  const navigate = useNavigate();
  const [templateSet, setTemplateSet] = useState<TemplateSet>(
    new TemplateSet({ id: "", name: "", template_names: [], disabled: false }),
  );
  const [profiles, setProfiles] = useState<Profile[]>([]);

  const handleCreate = async () => {
    await templateSet.create();
    navigate("/template-sets");
  };

  const renderActionButtons = (): ReactElement => {
    const hasError = templateSet.hasErrors(templateSet.validate());
    return (
      <Button
        sx={{ marginRight: "7pt", marginTop: "10pt" }}
        onClick={handleCreate}
        variant="contained"
        disabled={hasError}
      >
        Create
      </Button>
    );
  };

  useEffect(() => {
    Profiles.list().then(setProfiles);
  }, []);

  return (
    <PageContainer>
      <TemplateSetForm
        actionButtons={renderActionButtons()}
        isUpdate={false}
        templateSet={templateSet}
        setTemplateSet={setTemplateSet}
        profiles={profiles}
      ></TemplateSetForm>
    </PageContainer>
  );
}

export default TemplateSetCreate;
